
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Comprendre le planogramme: Définition, Importance et Utilisation pratique en Commerce",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Comprenez l'importance et le rôle du planogramme dans la gestion d'espace de vente. Découvrez la définition planogramme pour optimiser l'arrangement de vos produits.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Comprendre le planogramme: Définition, Importance et Utilisation pratique en Commerce",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Comprenez l'importance et le rôle du planogramme dans la gestion d'espace de vente. Découvrez la définition planogramme pour optimiser l'arrangement de vos produits.",
        },
      ],
    };
  },
};
